import React from 'react';
import styled from 'styled-components';

import Logo from "src/assets/icons/Logo.svg";
import Mic from "src/assets/icons/microphone.svg";
import Video from "src/assets/icons/video.svg";
import Respond from "src/assets/icons/respond.svg";
import Bell from "src/assets/icons/Notifications.svg";

import { FiBell, FiSearch, FiChevronLeft, FiChevronRight, FiChevronDown } from "react-icons/fi";
import { theme } from '../styles/theme';
import Verizon from "src/assets/brands/verizon.png";
import QcastLogo from "src/assets/brands/qcast_logo.svg";

// Styled Components
const HeaderContainer = styled.div`
    width: 100%;
    height: 78px;
    padding: 16px 20px;

    display: flex;
    align-items: center;
    justify-content: space-between;
    background: white;
    // box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
    @media (max-width: ${theme.breakpoints.mobile}px) {
      height: 45px;
  }
`;

const LogoSection = styled.div`
  display: flex;
  align-items: center;
  width: 470px;
/* 
  @media (max-width: ${theme.breakpoints.desktop}px) {
    width: 24.48%;
  }

  @media (max-width: ${theme.breakpoints.mobile}px) {
    width: 24.48%;
  }

  @media (max-width: ${theme.breakpoints.tablet}px) {
    width: 24.48%;
  }

  @media (max-width: ${theme.breakpoints.maxTablet}px) {
    width: 24.48%;
  }

  @media (max-width: ${theme.breakpoints.maxDesktop}px) {
    width: 24.48%;
  } */
`;

const LogoButton = styled.button`
  display: flex;
  align-items: center;
  background: none;
  border: none;
  padding: 8px;
  cursor: pointer;
  margin-right: 8px;
  // gap: 16px;

  img{
    width: 120px;
    height: auto;
  }
  @media (max-width: ${theme.breakpoints.mobile}px) {
    img{
    width: 60px;
    height: auto;
  }
  }
  
`;

const LogoText = styled.span`
  font-weight: 500;
  font-size: 16px;
  margin-left: 4px;
`;

const NavigationButtons = styled.div`
  display: flex;
  margin: 0 16px;
`;

const Middle = styled.div`
  //width: 940px;
  height: 46px;
  gap: 14px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 14px;
/* 
  @media (max-width: ${theme.breakpoints.desktop}px) {
    width: 48.96%;
  }

  @media (max-width: ${theme.breakpoints.mobile}px) {
    width: 48.96%;
  }

  @media (max-width: ${theme.breakpoints.tablet}px) {
    width: 48.96%;
  }

  @media (max-width: ${theme.breakpoints.maxTablet}px) {
    width: 48.96%;
  }

  @media (max-width: ${theme.breakpoints.maxDesktop}px) {
    width: 48.96%;
  } */
`;

const NavButton = styled.button`
  background: none;
  border: none;
  border-radius: 50%;
  padding: 8px;
  cursor: pointer;
  margin: 0 2px;
  height: 46px;

`;

const SearchContainer = styled.div`
  display: flex;
  align-items: center;
  flex: 1;
  max-width: 720px;
  background-color: #f1f3f4;
  border-radius: 24px;
  padding: 0 16px;
  height: 46px;
  margin: 0 auto;

  width: 800px;
`;

const SearchInput = styled.input`
  flex: 1;
  border: none;
  background: transparent;
  padding: 0 8px;
  font-size: 16px;
  outline: none;
`;

const VoiceSearchButton = styled.button`
  background: none;
  border: none;
  border-radius: 50%;
  padding: 8px;
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;

  background: #3944E11A;
  
  &:hover {
    background-color: rgba(0, 0, 0, 0.05);
  }
`;

const ActionsContainer = styled.div`
  width: 470px;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 20px;
`;

const ActionButtons = styled.div`
  width: 220px;
  height: 46px;
  gap: 16px;
  border-radius: 100px;
  padding: 10px 20px;
  background: #F2EFF9;
  display: flex;
  align-items: center;
  justify-content: space-between;

  &>.divider{
    angle: -90 deg;
    opacity: 0.2;
    border-width: 1px;
    border-left: 2px solid var(--Innovation-Indigo, #4513AA);
    color: #4513AA;
  }
`;

const ActionButton = styled.button`
  background: none;
  border: none;
  border-radius: 8px;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 8px;

  color: var(--Innovation-Indigo, #4513AA);

  &>span{
    font-family: ${theme.fonts.primary};
    font-weight: ${theme.fontWeights.bold};
    font-size: ${theme.fontSizes.base};
    line-height: 135%;
    letter-spacing: 0%;
  }
`;

const NotificationButton = styled.button`
  background: none;
  border: none;
  border-radius: 50%;
  padding: 8px;
  cursor: pointer;
  margin-left: 8px;
  
  &:hover {
    background-color: rgba(0, 0, 0, 0.05);
  }
`;

const ProfileImage = styled.img`
  width: 28px;
  height: 28px;
  border-radius: 50%;
  cursor: pointer;
`;

// Component Interface
interface HeaderProps {
  onLogoClick?: () => void;
  onSearchSubmit?: (query: string) => void;
  onAskClick?: () => void;
  onAnswerClick?: () => void;
  profileImageSrc?: string;
}

const Header: React.FC<HeaderProps> = ({
    onLogoClick,
    onSearchSubmit,
    onAskClick,
    onAnswerClick,
    profileImageSrc = "https://randomuser.me/api/portraits/women/44.jpg",
  }) => {
  const [searchQuery, setSearchQuery] = React.useState<string>("");

  const handleSearchSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (onSearchSubmit) {
      onSearchSubmit(searchQuery);
    }
  };

  return (
    <HeaderContainer>
      <LogoSection>
        <LogoButton onClick={onLogoClick}>
          <img src={QcastLogo} />
          {/* <LogoText>Verizon</LogoText> */}
          {/* <FiChevronDown size={20} /> */}
        </LogoButton>
      </LogoSection>

      <Middle>
        {/* <NavigationButtons>
          <NavButton>
            <FiChevronLeft size={20} />
          </NavButton>
          <NavButton>
            <FiChevronRight size={20} color={"#A3A3A3"} />
          </NavButton>
        </NavigationButtons> */}

        {/* <SearchContainer>
          <FiSearch size={20} color="#5f6368" />
          <form onSubmit={handleSearchSubmit} style={{ display: 'flex', flex: 1 }}>
            <SearchInput
              placeholder="Search"
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
            />
          </form>
          
        </SearchContainer> */}
        {/* <VoiceSearchButton>
          <img src={Mic} />
        </VoiceSearchButton> */}
      </Middle>

      <ActionsContainer>
        {/* <ActionButtons>
          <ActionButton onClick={onAskClick}>
            <img src={Video} style={{ marginRight: 4 }} />
            <span>Ask</span>
          </ActionButton>
          <div className="divider">&nbsp;</div>
          <ActionButton onClick={onAnswerClick}>
            <img src={Respond} style={{ fontSize: '20px', marginRight: 4 }} />
            <span>Answer</span>
          </ActionButton>
        </ActionButtons> */}
        
        {/* <NotificationButton>
          <img src={Bell} />
        </NotificationButton>
        <ProfileImage src={profileImageSrc} alt="Profile" /> */}
      </ActionsContainer>
    </HeaderContainer>
  );
};

export default Header;